// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"15799285","239":"e0b5a7ce","453":"9e76aedb","455":"ac007717"}[chunkId] + ".chunk.js";
};